export default "__VITE_ASSET__1Yaa$Vgc__"